export default __webpack_public_path__ + "static/media/a012-9.cd0c91af.svg";